import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  scope: "col",
  class: "px-6 py-3 text-left text-sm font-medium text-gray-700 first-letter:capitalize tracking-wider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("th", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}